'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from "react-router-dom";

import Instagram from './components/Instagram';
import Products from './components/Products';

//instagram
if (window.Instagram)
    ReactDOM.render(
        <Instagram token={ window.Instagram.token }></Instagram>,
        document.getElementById('instagram')
    );

ReactDOM.render(
    <Router>
        <Route
            path="/produtos/:type?/:category?"
            component={ Products } />
    </Router>,
    document.getElementById('products')
)


//Limpar códigos
import './jquery';


// WEBPACK FOOTER //
// ./resources/assets/js/app/app.js